import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-casto-contact',
  templateUrl: './contact.component.html',
})
export class ContactComponent {
  constructor(public modalService: ModalService) {}
}
